/**
 * ScoreLegend.tsx — static Opportunity Score gradient legend (T-012/W1).
 *
 * A small glass overlay showing the 5-tier color scale used by the tract
 * choropleth (TractLayer fill-color stops). Read-only; mirrors the prototype's
 * desktop header gradient strip. Colors match TractLayer's interpolate stops.
 */
const TIERS = [
  { label: 'Low', color: '#ef4444' }, // < 35  (Unfavourable)
  { label: 'Marginal', color: '#f97316' }, // ≥ 35
  { label: 'Moderate', color: '#f59e0b' }, // ≥ 45
  { label: 'Strong', color: '#4ade80' }, // ≥ 60
  { label: 'Prime', color: '#15803d' }, // ≥ 70
]

export function ScoreLegend() {
  return (
    <div className="glass rounded-lg border border-border/60 shadow-md px-2.5 py-2 w-48">
      <p className="text-[0.625rem] font-bold uppercase tracking-widest text-muted-foreground mb-1.5">
        Opportunity Score
      </p>
      <div
        className="h-2 w-full rounded-full mb-1.5"
        style={{
          background: 'linear-gradient(to right, #ef4444, #f97316, #f59e0b, #4ade80, #15803d)',
        }}
        aria-hidden="true"
      />
      <div className="flex justify-between">
        {TIERS.map((t) => (
          <div key={t.label} className="flex flex-col items-center gap-0.5">
            <span
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: t.color }}
              aria-hidden="true"
            />
            <span className="text-[9px] text-muted-foreground">{t.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
